import { AxiosResponse } from 'axios';

import api from '~/services/api';
import { AuditUserLogInterface } from './audit-user-interface';

class AuditClientService {
  getListAllAuditUserLog(
    { skip = 0, limit = 10, ...rest },
    opts?: any
  ): Promise<AxiosResponse<AuditUserLogInterface[] | null>> {
    return api.get('/audit-log/', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getRowCount({ ...rest }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/audit-log/count', {
      params: {
        ...rest
      },
      ...opts
    });
  }
}

export default new AuditClientService();
